import React from "react";

import async from "../../components/Async";
import {RouterState, RouterStore} from "mobx-state-router";
import {DefaultSettingList} from "../../models/defaultSetting/DefaultSettingList";
import {DefaultSettingListViewState} from "../../components/defaultSetting/list/DefaultSettingListViewState";
import {buildDefaultSettingsColumns} from "../../components/defaultSetting/list/DefaultSettingListView";
import {faGear} from "@fortawesome/free-solid-svg-icons";
import {DefaultSettingFormState} from "../../components/defaultSetting/forms/DefaultSettingFormState";
import {DefaultSettingModel} from "../../models/defaultSetting/DefaultSettingModel";
import {ModalState} from "../../components/elements/modal/GenericModal";

// Page Async Reference, for lazy loading in UI
const DefaultSettingListHome = async(()=> import("../../pages/defaultSetting/defaultSettingListHome"));
const CreateDefaultSettingHome = async(()=> import("../../pages/defaultSetting/createDefaultSettingHome"));
const EditDefaultSettingHome = async(()=> import("../../pages/defaultSetting/editDefaultSettingHome"));
export const viewMap = {
  defaultSettings: <DefaultSettingListHome/>,
  createDefaultSetting: <CreateDefaultSettingHome/>,
  editDefaultSetting: <EditDefaultSettingHome/>
};
export const routeDefinitions = [
  {
    path: "defaultSettings",
    name: "Default Settings",
    icon: faGear,
    component: DefaultSettingListHome,
    children: null,
    featureFlagRequired: "cmp_ui_default_settings"
  },
];
export const routeTransitions = [
  {
    name: "defaultSettings",
    pattern: "/default-settings",
    onEnter: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
      const groupSelectState = rootStore.rootUiStore.groupSelectStore;
      const defaultSettingStore = rootStore.domainStore.defaultSettingStore;
      const defaultSettingList = DefaultSettingList.create({
        items:defaultSettingStore
      });
      const advFilterSelectState = rootStore.rootUiStore.filterSelectState;
      const codeOwnerFilterSelectState = rootStore.rootUiStore.codeOwnerFilterSelectState;
      const dimensionSelectViewState = rootStore.rootUiStore.dimensionSelectViewState;
      const groupFilterSelectState = rootStore.rootUiStore.groupFilterSelectState;
      advFilterSelectState.reset();
      codeOwnerFilterSelectState.reset();
      dimensionSelectViewState.reset();
      groupFilterSelectState.reset();
      const modalState = ModalState.create({});
      const defaultSettingListViewState = DefaultSettingListViewState.create({
        listModel:defaultSettingList,
        groupSelectStore: groupSelectState,
        advFilterSelectState: advFilterSelectState,
        codeOwnerFilterSelectState: codeOwnerFilterSelectState,
        dimensionSelectViewState: dimensionSelectViewState,
        groupFilterSelectState: groupFilterSelectState,
        modalStore: modalState,
      });
      defaultSettingListViewState?.loadColumnsFromSession();
      defaultSettingListViewState.setColumns(buildDefaultSettingsColumns(routerStore, defaultSettingListViewState))
      await rootStore.rootUiStore.attachPageState("defaultSettingListViewState", defaultSettingListViewState);
      defaultSettingListViewState.getFilters();
      defaultSettingListViewState.refresh();
      // await  rootStore.rootUiStore.defaultSettingListViewState?.getFilters();

    },
    onExit: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
const {rootStore} = routerStore.options;
    }
  },
  {
    name: 'createDefaultSetting',
    pattern: '/default-settings/create',
    // beforeEnter: checkUserPermissions,
    onEnter: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      let {queryParams} = toState;
      const {rootStore} = routerStore.options;
      const groupSelectStore = rootStore.rootUiStore.groupSelectStore;
      const dimensionSelectViewState = rootStore.rootUiStore.dimensionSelectViewState;
      const tenantStore = rootStore.domainStore.tenantStore;
      groupSelectStore?.selectDefaultGroup(tenantStore.defaultGroupUuid);
      const utmSelectState = rootStore.rootUiStore.utmSelectState;
      const qrConfigSelectState = rootStore.rootUiStore.qrConfigSelectStore;
      const parameterSetSelectState = rootStore.rootUiStore.parameterSetSelectState;
      const codeTypeSelectState = rootStore.rootUiStore.codeTypeSelectStore;
      const extendedDataSetSelectState = rootStore.rootUiStore.extendedDataSetSelectStore;
      const extendedDataStore = rootStore.domainStore.extendedDataStore;
      await extendedDataStore.init();
      utmSelectState.store.setFilterOn(tenantStore.defaultGroupUuid)
      utmSelectState.store.init()
      // extendedDataSetSelectState.store.setFilterOn(tenantStore.defaultGroupUuid)
      extendedDataSetSelectState.store.init()
      parameterSetSelectState.store.setFilterOn(tenantStore.defaultGroupUuid)
      parameterSetSelectState.store.init()

      const defaultSettingFormState = DefaultSettingFormState.create({
        defaultSetting: DefaultSettingModel.create({uuid:"Create Default Setting"}),
        groupSelectStore: groupSelectStore,
        dimensionSelectViewState: dimensionSelectViewState,
        utmSelectState : utmSelectState,
        qrConfigSelectState: qrConfigSelectState,
        parameterSetSelectState: parameterSetSelectState,
        codeTypeSelectStore:codeTypeSelectState,
        extendedDataSetSelectStore: extendedDataSetSelectState,
      })


      await rootStore.rootUiStore.attachPageState('defaultSettingFormState', defaultSettingFormState);
      groupSelectStore?.clearSelected()
      utmSelectState?.setSelectedUtm()
      qrConfigSelectState?.setSelectedConfig()
      parameterSetSelectState?.setSelectedParameterSet()
      codeTypeSelectState?.clear()
      extendedDataSetSelectState?.setSelectedExtendedData()
      defaultSettingFormState?.dimensionSelectViewState?.dimensionSelectStates?.map(dimensionSelectStore => dimensionSelectStore.clearSelectedDimensions())

    },
    onExit: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
    }
  },
  {
    name: 'editDefaultSetting',
    pattern: '/default-settings/edit/:uuid',
    // beforeEnter: checkUserPermissions,
    onEnter: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
      let {queryParams,params} = toState;
      const groupSelectStore = rootStore.rootUiStore.groupSelectStore;
      const dimensionSelectViewState = rootStore.rootUiStore.dimensionSelectViewState;
      const tenantStore = rootStore.domainStore.tenantStore;
      groupSelectStore?.selectDefaultGroup(tenantStore.defaultGroupUuid);
      const utmSelectState = rootStore.rootUiStore.utmSelectState;
      const qrConfigSelectState = rootStore.rootUiStore.qrConfigSelectStore;
      const parameterSetSelectState = rootStore.rootUiStore.parameterSetSelectState;
      const codeTypeSelectState = rootStore.rootUiStore.codeTypeSelectStore;
      const extendedDataSetSelectState = rootStore.rootUiStore.extendedDataSetSelectStore;

      utmSelectState.store.setFilterOn(tenantStore.defaultGroupUuid)
      utmSelectState.store.init()
      extendedDataSetSelectState.store.init()
      parameterSetSelectState.store.setFilterOn(tenantStore.defaultGroupUuid)
      parameterSetSelectState.store.init()


      const defaultSettingFormState = DefaultSettingFormState.create({
        defaultSetting: DefaultSettingModel.create({uuid:"Create Default Setting"}),
        groupSelectStore: groupSelectStore,
        dimensionSelectViewState: dimensionSelectViewState,
        utmSelectState : utmSelectState,
        qrConfigSelectState: qrConfigSelectState,
        parameterSetSelectState: parameterSetSelectState,
        codeTypeSelectStore:codeTypeSelectState,
        extendedDataSetSelectStore: extendedDataSetSelectState,
      })
      await rootStore.rootUiStore.attachPageState('defaultSettingFormState', defaultSettingFormState);
      codeTypeSelectState?.clear()
      groupSelectStore?.clearSelected()
      defaultSettingFormState?.dimensionSelectViewState?.dimensionSelectStates?.map(dimensionSelectStore => dimensionSelectStore.clearSelectedDimensions())
      const result = await defaultSettingFormState?.fetchModelAndHydrate(params.uuid)
      defaultSettingFormState?.defaultSetting?.hydrateDefaultSetting(result,defaultSettingFormState?.defaultSetting)
      defaultSettingFormState?.checkExperienceType()

    },
    onExit: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
    }
  },
]
